const EditOwner = () => {
  return (
    <div>
      <h1>Edit Owner</h1>
    </div>
  );
};

export default EditOwner;
